import {Embeds} from './Embeds';

export * from './Embeds';

export default Embeds;
